export default __webpack_public_path__ + "static/image16-d4daa9e60c8c1c74e478b6c2102350ca.jpg";